import { UserReviewLoading } from '../UserReview/UserReviewLoading'
import styles from './ListLoading.module.css'

interface ListLoadingProps {
  amount?: number
}

export function ListLoading({ amount = 10 }: ListLoadingProps) {
  const reviewLoadings = []
  for (let i = 0; i < amount; i++) {
    reviewLoadings.push(<UserReviewLoading key={i} className={styles.loadingCard} />)
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>{reviewLoadings}</div>
    </div>
  )
}
